import React from "react";
import Link from "next/link";
import Image from "next/image";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import {
  certifications,
  capterraCertifications,
} from "@constants/certifications";
import { BASE_ASSETS_URL } from "@constants/constants";
import Certifications from "@components/Security/Certifications";

const footerLinks = [
  {
    title: "Company",
    links: [
      {
        title: "About Us",
        href: "/about",
        excludePages: [],
      },
      // {
      //   title: "Integrations",
      //   href: "/integrations",
      //   excludePages: [],
      // },
      // {
      //   title: "Our Team",
      //   href: "/our-team",
      //   excludePages: [],
      // },
      // {
      //   title: "Careers",
      //   href: "/careers",
      //   excludePages: [],
      // },
      // {
      //   title: "Contact Us",
      //   href: "/contact-us",
      //   excludePages: [],
      // },
    ],
  },
  {
    title: "Solutions",
    links: [
      {
        title: "Sign Documents Online",
        href: "https://signature.boloforms.com",
        excludePages: [],
      },
      {
        title: "ThePDFMaker",
        href: "https://thepdfmaker.com/",
        excludePages: [],
      },
      {
        title: "Document Signing API",
        href: "/signature/api",
        excludePages: [],
      },
      {
        title: "Embedding",
        href: "/signature/embedding",
        excludePages: [],
      },
      {
        title: "Accept Payments",
        href: "/blog/connect-to-stripe-and-accept-payments-in-bolosign",
        excludePages: [],
      },
      {
        title: "Enterprise",
        href: "/signature/enterprise",
        excludePages: [],
      },
      {
        title: "SOC 2 Compliance",
        href: "/signature/soc",
        excludePages: [],
      },
      {
        title: "Wordpress Integration",
        href: "/signature/wordpress-integration",
        excludePages: [],
      },
      {
        title: "Whitelabel Partnership",
        href: "/signature/whitelabel",
        excludePages: [],
      },
      {
        title: "Mobile Apps",
        href: "/signature/mobile",
        excludePages: [],
      },
    ],
  },
  {
    title: "Resources",
    links: [
      {
        title: "What is an eSignature?",
        href: "/signature/what-is-electronic-signature",
        excludePages: [],
      },
      {
        title: "Are eSignatures legal?",
        href: "/signature/electric-signature-legality",
        excludePages: [],
      },
      {
        title: "Comparisons",
        href: "/signature/alternatives",
        excludePages: [],
      },
      // {
      //   title: "Affiliate Program",
      //   href: "/signature/affiliates",
      //   excludePages: [],
      // },
      {
        title: "Blogs",
        href: "/blog",
        excludePages: [],
      },
      {
        title: "Customers",
        href: "/customers",
        excludePages: [],
      },
      {
        title: "Online Signature Maker",
        href: "/signature/online-signature",
        excludePages: [],
      },
      {
        title: "PDF Tools",
        href: "/signature/pdf-tools",
        excludePages: [],
      },
      {
        title: "Calculators",
        href: "/calculators",
        excludePages: [],
      },
    ],
  },
  {
    title: "Legal & Security",
    links: [
      {
        title: "Terms of Service",
        href: "/terms-of-service",
        excludePages: [],
      },
      {
        title: "Privacy Policy",
        href: "/privacy-policy",
        excludePages: [],
      },
      {
        title: "Refund Policy",
        href: "/refund-policy",
        excludePages: [],
      },
      {
        title: "Data Security & Policy",
        href: "https://security.boloforms.com/",
        excludePages: [],
      },
    ],
  },
];

const socialLinks = [
  {
    title: "Facebook",
    url: "https://www.facebook.com/boloforms/",
    icon: <FaFacebookF />,
  },
  {
    title: "Instagram",
    url: "https://www.instagram.com/boloforms/",
    icon: <FaInstagram />,
  },
  {
    title: "Twitter",
    url: "https://x.com/BoloForms",
    icon: <FaXTwitter />,
  },
  {
    title: "LinkedIn",
    url: "https://www.linkedin.com/company/boloforms/",
    icon: <FaLinkedinIn />,
  },
];

const Footer = () => {
  return (
    <div className="w-full bg-white">
      <footer className="">
        <div className="mx-auto max-w-screen-mxl space-y-8 px-4 pt-16 sm:px-6 lg:space-y-16 lg:px-8 sm:grid lg:block place-items-center">
          <div className="flex flex-col lg:flex-row justify-between gap-10">
            <div className="">
              <div className="text-gray-900">
                <Link href={`/`} className={`flex items-center space-x-1`}>
                  <Image
                    src="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/BoloForms.png"
                    className={"w-40  h-16 md:h-16 md:w-30"}
                    width={100}
                    height={100}
                    loading="lazy"
                    alt="BoloForms Logo"
                  />
                </Link>
              </div>
              <p className="mt-4 max-w-xs text-gray-900 text-lg">
                {`Unlimited signatures, templates, forms, contracts, and team members—all for a fixed price. No additional charges for extra signatures or users, ever.`}
              </p>
              <div className="mt-8">
                <p className="text-lg">
                  <span className="">Email: </span>
                  <Link
                    href={`mailto:support@boloforms.com`}
                    className="text-gray-900 hover:text-violet-500"
                  >
                    support@boloforms.com
                  </Link>
                </p>
                <div className="mt-4 flex items-center gap-6">
                  {socialLinks.map((link, index) => (
                    <Link
                      key={index}
                      href={link.url}
                      rel="noreferrer"
                      target="_blank"
                      className="text-gray-900 text-md border border-gray-900 grid place-items-center rounded-full w-8 h-8 transition hover:bg-violet-500 hover:text-white hover:border-violet-500"
                    >
                      <span className="sr-only">{link.title}</span>
                      {link.icon}
                    </Link>
                  ))}
                </div>
                <div className="flex items-center justify-start gap-4 mt-4">
                  {capterraCertifications.map((certification, index) => (
                    <div
                      key={index}
                      // href={certification.link}
                      className="flex flex-col gap-3 justify-end items-center"
                    >
                      <Image
                        src={certification.image}
                        className={`h-16 w-auto`}
                        width={20}
                        height={20}
                        loading="lazy"
                        alt={certification.name}
                      />
                      {/* <p className="text-xs sm:text-sm text-gray-800 text-center w-[95px]">
                        {certification.name}
                      </p> */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-10 xl:gap-20 lg:grid-cols-3">
              <div className="">
                <h2 className="text-gray-900 text-3xl font-bold cursor-default">
                  {footerLinks[0].title}
                </h2>
                <ul className="mt-6 space-y-4 text-lg">
                  {footerLinks[0].links.map((link, index) => (
                    <li key={index}>
                      <Link
                        href={`${link.href}`}
                        className="text-gray-900 hover:text-violet-500 block"
                      >
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>

                <div className="mt-8">
                  <h2 className="text-gray-900 text-3xl font-bold cursor-default">
                    Solutions
                  </h2>

                  <ul className="mt-6 space-y-4 text-lg">
                    {footerLinks[1].links.map((link, index) => (
                      <li key={index}>
                        <Link
                          href={`${link.href}`}
                          className="text-gray-900 hover:text-violet-500 block"
                        >
                          {link.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="">
                <h2 className="text-gray-900 text-3xl font-bold cursor-default">
                  {footerLinks[2].title}
                </h2>
                <ul className="mt-6 space-y-4 text-lg">
                  {footerLinks[2].links.map((link, index) => (
                    <li key={index}>
                      <Link
                        href={`${link.href}`}
                        className="text-gray-900 hover:text-violet-500 block"
                      >
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  <h2 className="text-gray-900 text-3xl font-bold cursor-default">
                    Sales Inquiry
                  </h2>

                  <ul className="mt-6 space-y-4">
                    <li>
                      <a
                        href={`tel:+14156496611`}
                        className="text-gray-900 hover:text-violet-500 block flex items-center gap-2"
                      >
                        +1 (415) 6496611
                      </a>
                      <p className="text-gray-900 text-sm inline border border-gray-700 px-2 py-0.5 rounded">
                        8 AM - 7 PM (ET)
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="">
                <h2 className="text-gray-900 text-3xl font-bold cursor-default">
                  {footerLinks[3].title}
                </h2>
                <ul className="mt-6 space-y-4 text-lg">
                  {footerLinks[3].links.map((link, index) => (
                    <li key={index}>
                      <Link
                        href={`${link.href}`}
                        className="text-gray-900 hover:text-violet-500 block"
                      >
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
                <div className="my-6">
                  <h2 className="text-gray-900 text-3xl font-bold">
                    Available on:
                  </h2>
                  <div className="flex flex-col items-start justify-start flex-wrap gap-4 mt-6">
                    <Link
                      href={`https://apps.apple.com/app/bolosign-upload-sign-send/id6717583531`}
                    >
                      <Image
                        src={require(`@assets/footer/apple-store.png`)}
                        className={`h-12 w-auto`}
                        width={20}
                        height={20}
                        loading="lazy"
                        alt={""}
                      />
                    </Link>
                    <Link
                      href={`https://play.google.com/store/apps/details?id=com.boloforms.signature`}
                    >
                      <Image
                        src={require(`@assets/footer/play-store.png`)}
                        className={`h-12 w-auto`}
                        width={20}
                        height={20}
                        loading="lazy"
                        alt={""}
                      />
                    </Link>
                    <Link
                      href={`https://workspace.google.com/marketplace/app/signature_in_google_forms_by_bolo_sign_p/147316795411`}
                    >
                      <Image
                        src={require(`@assets/footer/gsuite.png`)}
                        className={`h-9 w-auto`}
                        width={20}
                        height={20}
                        loading="lazy"
                        alt={""}
                      />
                    </Link>
                    <Link
                      href={`https://chromewebstore.google.com/detail/bolosign-for-gmail-esigna/epnpemncgmeholkoakbhhdhniahggpna`}
                    >
                      <Image
                        src={`${BASE_ASSETS_URL}/v2/footer/gmail.png`}
                        className={`h-8 w-auto`}
                        width={20}
                        height={20}
                        loading="lazy"
                        alt={""}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex flex-col gap-8">
            <Certifications
              certifications={certifications}
              customStyling="gap-4 sm:gap-8"
            />
            <p className="py-6 w-full text-xl text-gray-900 text-center border-t border-gray-600">
              © 2025. Closer Innovation Labs Corp. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
